import React from 'react';
import '../inc/genstyle.css';

export const FormErrors = ({formErrors}) =>
    <div className='w100p textLeft'>
        { formErrors !== ''? <div className="errText">{formErrors}</div> : '' }
    </div>